export { MessageCard } from './MessageCard'


// WEBPACK FOOTER //
// ../../src/MessageCard/index.js